import React from 'react';
import { Box, Container } from '@chakra-ui/react';
import ChatWindow from '../../components/chatbot/ChatWindow';

const ChatbotPage: React.FC = () => {
  return (
    <Box py={8}>
      <Container maxW="container.md">
        <ChatWindow />
      </Container>
    </Box>
  );
};

export default ChatbotPage;
